var chunkMapping = {
	"4": [
		919,
		5363
	],
	"44": [
		6730,
		8927
	],
	"50": [
		4535,
		1514
	],
	"124": [
		5996,
		4260
	],
	"143": [
		8288,
		9925
	],
	"216": [
		2216
	],
	"257": [
		8530,
		1463
	],
	"284": [
		9136,
		1796
	],
	"323": [
		3326,
		909
	],
	"416": [
		2478,
		9399
	],
	"436": [
		8203,
		140
	],
	"437": [
		6189,
		6592
	],
	"448": [
		389,
		3131
	],
	"524": [
		1524
	],
	"648": [
		7641,
		8789
	],
	"658": [
		7224,
		3390
	],
	"674": [
		9750
	],
	"748": [
		3059,
		5430
	],
	"794": [
		4249,
		5017
	],
	"809": [
		4157
	],
	"816": [
		1816
	],
	"821": [
		8650,
		8920
	],
	"848": [
		9022,
		4858
	],
	"894": [
		3379,
		9690
	],
	"907": [
		5338,
		4438
	],
	"911": [
		8327,
		549
	],
	"931": [
		931
	],
	"965": [
		6954,
		4933
	],
	"970": [
		1970
	],
	"982": [
		2291,
		283
	]
};
var idToExternalAndNameMapping = {
	"140": [
		"default",
		"./CommentText",
		9018
	],
	"283": [
		"default",
		"./OperationHistorySearchSkeleton",
		9531
	],
	"389": [
		"default",
		"./QuickButton",
		9018
	],
	"549": [
		"default",
		"./GlobalStore",
		7664
	],
	"909": [
		"default",
		"./ButtonBannerSkeleton",
		9018
	],
	"919": [
		"default",
		"./InputAmount",
		9018
	],
	"931": [
		"default",
		"./utils",
		9018
	],
	"1463": [
		"default",
		"./SwipeableList",
		9018
	],
	"1514": [
		"default",
		"./SpendingCellSkeleton",
		9018
	],
	"1524": [
		"default",
		"./SwipeableListItem",
		9018
	],
	"1796": [
		"default",
		"./Slider",
		9018
	],
	"1816": [
		"default",
		"./ToggleButtons",
		9018
	],
	"1970": [
		"default",
		"./SwipeableListItem/useAnimateSwipeItem",
		9018
	],
	"2216": [
		"default",
		"./hooks",
		9018
	],
	"2291": [
		"default",
		"./LocalizationDictionary",
		1602
	],
	"2478": [
		"default",
		"./DisablePageOverlay",
		9018
	],
	"3059": [
		"default",
		"./AnimateHeightComponent",
		9018
	],
	"3131": [
		"default",
		"./QuickButtonSkeleton",
		9018
	],
	"3326": [
		"default",
		"./ButtonBanner",
		9018
	],
	"3379": [
		"default",
		"./NewDatePicker",
		9018
	],
	"3390": [
		"default",
		"./BasicCellTitleSkeleton",
		9018
	],
	"4157": [
		"default",
		"./ServiceHandler",
		7454
	],
	"4249": [
		"default",
		"./Loader",
		9018
	],
	"4260": [
		"default",
		"./IntegrationHub",
		7910
	],
	"4438": [
		"default",
		"./ErrorBox",
		9018
	],
	"4535": [
		"default",
		"./SpendingCell",
		9018
	],
	"4858": [
		"default",
		"./OperationHistoryToggleButtonsSkeleton",
		9531
	],
	"4933": [
		"default",
		"./NavBar",
		9018
	],
	"5017": [
		"default",
		"./LoaderBlocker",
		9018
	],
	"5338": [
		"default",
		"./Doughnut",
		9018
	],
	"5363": [
		"default",
		"./Layout",
		9018
	],
	"5430": [
		"default",
		"./BasicCellTitle",
		9018
	],
	"5996": [
		"default",
		"./WriterStore",
		7664
	],
	"6189": [
		"default",
		"./Icon",
		9018
	],
	"6592": [
		"default",
		"./Infobox",
		9018
	],
	"6730": [
		"default",
		"./RightSheetComponent",
		9018
	],
	"6954": [
		"default",
		"./Modal",
		9018
	],
	"7224": [
		"default",
		"./BasicCellTitleAtoms",
		9018
	],
	"7641": [
		"default",
		"./chronology_v0",
		199
	],
	"8203": [
		"default",
		"./Cashback",
		9018
	],
	"8288": [
		"default",
		"./OperationCell",
		9018
	],
	"8327": [
		"default",
		"./UnexpectedErrorBlock",
		4328
	],
	"8530": [
		"default",
		"./Status",
		9018
	],
	"8650": [
		"default",
		"./BottomSheet",
		9018
	],
	"8789": [
		"default",
		"./statement_v0",
		199
	],
	"8920": [
		"default",
		"./Button",
		9018
	],
	"8927": [
		"default",
		"./Search",
		9018
	],
	"9022": [
		"default",
		"./OperationHistorySuspenseLoader",
		9531
	],
	"9136": [
		"default",
		"./Skeleton",
		9018
	],
	"9399": [
		"default",
		"./Divider",
		9018
	],
	"9690": [
		"default",
		"./NotificationToast",
		9018
	],
	"9750": [
		"default",
		"./hoc",
		9018
	],
	"9925": [
		"default",
		"./OperationDate",
		9018
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}